// extracted by mini-css-extract-plugin
module.exports = {"flex-container":"FlexContainer_flex-container__2QFkS","row":"FlexContainer_row__1ZKAS","row-reverse":"FlexContainer_row-reverse__2SuTP"};